import type { PlayerSliceDeps } from "../deps";
import type {
  PlayerStore,
  PreferencesState,
  PreferencesActions,
  NamedSlice,
} from "../types";

export const createPreferencesSlice = (
  deps: PlayerSliceDeps,
): NamedSlice<
  PreferencesState & { actions: PreferencesActions },
  PlayerStore
> => {
  return (set) => ({
    volume: 1,
    repeatMode: "off",
    shuffleEnabled: false,
    isAutoPlayEnabled: true,
    skipTimestamps: [],
    canSkip: true,
    canSkipReason: "none",

    actions: {
      setVolume: (volume: number) => {
        set(
          (state) => {
            state.volume = volume;
          },
          false,
          "preferences/setVolume",
        );
      },

      setGlobalRepeatMode: (mode) => {
        set(
          (state) => {
            state.repeatMode = mode;
          },
          false,
          "preferences/setGlobalRepeatMode",
        );
      },

      setGlobalShuffleEnabled: (enabled: boolean) => {
        set(
          (state) => {
            state.shuffleEnabled = enabled;
          },
          false,
          "preferences/setGlobalShuffleEnabled",
        );
      },

      setAutoPlayEnabled: (enabled: boolean) => {
        set(
          (state) => {
            state.isAutoPlayEnabled = enabled;
          },
          false,
          "preferences/setAutoPlayEnabled",
        );
      },

      registerSkip: () => {
        set(
          (state) => {
            state.skipTimestamps.push(new Date(deps.now()).toISOString());
          },
          false,
          "preferences/registerSkip",
        );
      },

      setCanSkip: (canSkip, reason) => {
        set(
          (state) => {
            state.canSkip = canSkip;
            state.canSkipReason = reason;
          },
          false,
          "preferences/setCanSkip",
        );
      },
    },
  });
};
